import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React from 'react'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import { useFlagsmithGetFlagValue } from 'lib/flagsmith'
import usePomeloCreditEnable from 'pages/user/pomelo-credit/usePomeloCreditEnable'
import { onClickSignOut, getUserOptions } from './utils'
import styles from './style.scss'
import UserLogoutOption from './user-logout-option'

const UserOptions = ({ currentPage, internationalization }) => {
  const isCreditEnable = usePomeloCreditEnable(internationalization.shop)
  const isCashbackEnable = usePomeloCreditEnable(internationalization.shop)
  const isMyLoyaltyEnable = useFlagsmithGetFlagValue(
    'LoyaltyEnabled_20230502',
    false,
  )

  const links = getUserOptions(
    internationalization,
    isCreditEnable,
    isCashbackEnable,
    isMyLoyaltyEnable,
  )

  const renderOptions = () =>
    links.map((link, index) => (
      <UserLogoutOption
        key={link.label}
        link={link}
        currentPage={currentPage}
        onClickSignOut={onClickSignOut}
        optionIndex={index}
      />
    ))

  return (
    <div className="page-container">
      <style jsx>{styles}</style>
      {renderOptions()}
    </div>
  )
}

UserOptions.propTypes = {
  currentPage: PropTypes.string,
  internationalization: PropTypes.shape({
    shop: PropTypes.number,
    country: PropTypes.string,
  }).isRequired,
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
  }).isRequired,
}

UserOptions.defaultProps = {
  currentPage: null,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    userInfo: state.auth.user,
    internationalization: state.internationalization,
  })),
  withI18next(),
)(UserOptions)
